export const Toast = {
  show: () => {

  },
  hide: () => {

  },
};

export default Toast;
